<template>
  <customModal
    :containersm="true"
    :footerShow="false"
    @closeModal="$emit('close')"
  >
    <template #title>
      {{ $t("navigations.link site") }}
    </template>

    <template #body>
      <div class="container-fluid">
        <div class="wrapper wrapper-content animated fadeInRight">
          <div class="ibox-content">
            <div class="row align-items-end">
              <div class="col-lg-8">
                <label class="mb-1">{{ $t("navigations.site code") }}</label>
                <Multiselect
                  v-model="selectedSites"
                  mode="multiple"
                  :searchable="true"
                  trackBy="value"
                  valueProp="value"
                  label="label"
                  :options="siteList"
                  :hideSelected="false"
                  :closeOnSelect="false"
                  :placeholder="$t('navigations.select site')"
                  class="multiselect-theme"
                  @change="onSiteChange"
                />
                <span class="errorClass" v-if="errors && errors.length">
                  {{ $t("navigations.please select at least one site") }}
                </span>
              </div>
              <div class="col-lg-4">
            <button
             
             class="save_btn py-1 px-4 w-100"
              @click="saveLinkedSite"
            >
              {{ $t("navigations.save") }}
            </button>
          </div>
         
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./linkSite.js"></script>

<style scoped>
.multiselect-theme {
  --ms-radius: 0;
  --ms-py: 0.4rem;
  --ms-option-font-size: 0.8rem;
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}

.errorClass {
  color: red;
  font-size: 0.8rem;
}

.wrapper-content {
  padding: 0.5rem;
}

.ibox-content {
  border: none;
  padding: 0.5rem 0;
}

.save_btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.max-height-400,
.height-400 {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
